 import React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import KeycloakProvider from 'react-lib/dist/keycloak-es';
import store, { history } from './store';
import 'react-dates/initialize';
import App from './App';
import 'semantic-ui-css/semantic.min.css';
import 'react-lib/dist/components-es.css';
import './index.css';
import './autocomplete.css';
import './style.css';
import './smallScreenStyle.css';
import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';
import { keycloakConfig } from './keycloak';
import LoadingComponent from './components/Loader/LoadingComponent';
import { QueryCache, QueryClient, QueryClientProvider } from 'react-query';
import { Worker } from '@react-pdf-viewer/core';

const queryCache = new QueryCache();
const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount: number, error: any) => {
        const { response } = error ?? {};
        if (response?.status === 403) {
          return false;
        }
        if (failureCount < 2) {
          return true;
        }
        return false;
      },
    },
  },
});

ReactDOM.render(
  <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
    <Provider store={store()}>
      <QueryClientProvider client={queryClient}>
        <ConnectedRouter history={history}>
          <KeycloakProvider keycloakConfig={keycloakConfig} LoadingComponent={LoadingComponent}>
            <App />
          </KeycloakProvider>
        </ConnectedRouter>
      </QueryClientProvider>
    </Provider>
  </Worker>,
  document.getElementById('root')
);
